import classNames from 'classnames';

import {
    BrowseNavigationItemSelected,
    BrowseNavigationItemType,
    BrowseNavigationItemStyle,
} from '@udemy/browse-event-tracking';
import {Tracker} from '@udemy/event-tracking';
import {useMatchMedia} from '@udemy/hooks';
import {useI18n} from '@udemy/i18n';
import {Image, Link} from '@udemy/react-core-components';

import styles from './topic-links.module.less';
import {Topic} from './types';
import {getCategoryIcon} from './utils';

export const TopicCard = ({id, iconCategoryId, name, link, enrollments}: Topic) => {
    const {ninterpolate} = useI18n();
    const isMobile = useMatchMedia('mobile-max');

    const trackClick = () => {
        Tracker.publishEvent(
            new BrowseNavigationItemSelected({
                id: id.toString(),
                type: BrowseNavigationItemType.TOPIC,
                style: BrowseNavigationItemStyle.PILL_VISUAL,
                uiRegion: 'skill_pills',
            }),
        );
    };

    return (
        <Link
            to={link}
            onClick={trackClick}
            disableRouter={true}
            target={!isMobile ? '_blank' : undefined}
            rel={!isMobile ? 'noopener noreferrer' : undefined}
        >
            <div className={styles.panel}>
                <div className={styles['category-icon']}>
                    <Image
                        src={getCategoryIcon(iconCategoryId).src}
                        alt=""
                        width={24}
                        height={24}
                    />
                </div>
                <div className={styles['panel-content']}>
                    <h3 className={classNames('ud-heading-md', styles['panel-title'])}>{name}</h3>
                    <span className={classNames('ud-text-xs', styles['panel-enrollments'])}>
                        {ninterpolate(
                            '%(enrollments)s learner',
                            '%(enrollments)s learners',
                            enrollments,
                            {
                                enrollments: enrollments.toLocaleString(undefined, {
                                    notation: 'compact',
                                    compactDisplay: 'short',
                                }),
                            },
                        )}
                    </span>
                </div>
            </div>
        </Link>
    );
};
